import { useMemo } from 'react'
import { Link } from 'react-router-dom'
import { Sparkles } from 'lucide-react'
import type { Product } from '@/types'
import { HomeProductGrid } from '@/store/components/HomeProductGrid'
import { SectionHeading } from '@/store/components/SectionHeading'

interface RecommendationsSectionProps {
  products: Product[]
}

export function RecommendationsSection({ products }: RecommendationsSectionProps) {
  const picks = useMemo(() => {
    if (products.length === 0) return []
    const featured = products.filter((p) => p.featured)
    const pool = featured.length >= 3 ? featured : products
    return [...pool].sort(() => 0.5 - Math.random()).slice(0, 3)
  }, [products])

  if (picks.length === 0) return null

  return (
    <section className="store-container py-12">
      <SectionHeading
        title="Recommended For You"
        subtitle="Curated luxury attars based on trending favourites"
        href="/shop"
      />
      <div className="flex items-center gap-2 text-gold-400/80 text-sm mb-6">
        <Sparkles className="h-4 w-4" /> Hand-picked fragrances
      </div>
      <HomeProductGrid products={picks} className="lg:grid-cols-3" />
      <div className="mt-6 text-center">
        <Link to="/shop" className="text-sm text-gold-400 hover:underline">
          Explore full collection
        </Link>
      </div>
    </section>
  )
}
